import { AddressStatusERPEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/addres-status-erp.enum';
import { OrderStatusERPEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/order-status-erp.enum';

export const ERP_STATUS_LABELS: Record<OrderStatusERPEnum, string> = {
  [OrderStatusERPEnum.ORDER_PENDING]: 'Pendiente envío a ERP',
  [OrderStatusERPEnum.ORDER_SEND]: 'Enviado a ERP',
  [OrderStatusERPEnum.ORDER_RECEIVED]: 'Recibido por ERP',
  [OrderStatusERPEnum.ORDER_CREATED]: 'Creado en ERP',
  [OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE]: 'Mod. pendiente de replicar',
  [OrderStatusERPEnum.ORDER_ERROR]: 'Error enviando a ERP',
  [OrderStatusERPEnum.ORDER_ERROR_ERP]: 'Error en ERP',
};

export const ERP_STATUS_CLASSES: Record<OrderStatusERPEnum, string> = {
  [OrderStatusERPEnum.ORDER_PENDING]: 'status-pending',
  [OrderStatusERPEnum.ORDER_SEND]: 'status-sent',
  [OrderStatusERPEnum.ORDER_RECEIVED]: 'status-received',
  [OrderStatusERPEnum.ORDER_CREATED]: 'status-created',
  [OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE]: 'status-modifications',
  [OrderStatusERPEnum.ORDER_ERROR]: 'status-error',
  [OrderStatusERPEnum.ORDER_ERROR_ERP]: 'status-rejected',
};

// Estados que nos interesan para sincronización
export const SYNCABLE_ERP_STATUSES = [
  OrderStatusERPEnum.ORDER_PENDING,
  OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE,
  OrderStatusERPEnum.ORDER_ERROR,
  OrderStatusERPEnum.ORDER_ERROR_ERP,
];

export const ADDRESS_STATUS_LABELS: Record<AddressStatusERPEnum, string> = {
  [AddressStatusERPEnum.ADDRESS_PENDING]: 'Pendiente envío a ERP',
  [AddressStatusERPEnum.ADDRESS_CREATED]: 'Creado en ERP',
  [AddressStatusERPEnum.ADDRESS_PENDING_FOR_UPDATE]: 'Mod. pendiente de replicar',
  [AddressStatusERPEnum.ADDRESS_FAILED_TO_SYNC]: 'Error al sincronizar',
};

export const ADDRESS_STATUS_CLASSES: Record<AddressStatusERPEnum, string> = {
  [AddressStatusERPEnum.ADDRESS_PENDING]: 'status-pending',
  [AddressStatusERPEnum.ADDRESS_CREATED]: 'status-created',
  [AddressStatusERPEnum.ADDRESS_PENDING_FOR_UPDATE]: 'status-modifications',
  [AddressStatusERPEnum.ADDRESS_FAILED_TO_SYNC]: 'status-error',
};

export const SYNCABLE_ADDRESS_STATUSES = [
  AddressStatusERPEnum.ADDRESS_PENDING,
  AddressStatusERPEnum.ADDRESS_PENDING_FOR_UPDATE,
  AddressStatusERPEnum.ADDRESS_FAILED_TO_SYNC,
];
